// extracted by mini-css-extract-plugin
module.exports = {"content":"FolderPage_content__22M0Z","accordion":"FolderPage_accordion__mafJx","tableView":"FolderPage_tableView__2GBhh"};